/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';
import Chip from '@mui/material/Chip';

const SCOPE_CHIP_COLORS: Record<
  string,
  { bg: string; color: string; border: string }
> = {
  Dedicated: {
    bg: 'rgba(59,130,246,0.15)',
    color: '#93c5fd',
    border: 'rgba(59,130,246,0.3)',
  },
  PlanShared: {
    bg: 'rgba(139,92,246,0.15)',
    color: '#c4b5fd',
    border: 'rgba(139,92,246,0.3)',
  },
  FarmShared: {
    bg: 'rgba(245,158,11,0.15)',
    color: '#fcd34d',
    border: 'rgba(245,158,11,0.3)',
  },
  RegionalShared: {
    bg: 'rgba(16,185,129,0.15)',
    color: '#6ee7b7',
    border: 'rgba(16,185,129,0.3)',
  },
  Platform: {
    bg: 'rgba(6,182,212,0.15)',
    color: '#67e8f9',
    border: 'rgba(6,182,212,0.3)',
  },
  Management: {
    bg: 'rgba(107,114,128,0.2)',
    color: '#d1d5db',
    border: 'rgba(107,114,128,0.3)',
  },
  Shared: {
    bg: 'rgba(245,158,11,0.15)',
    color: '#fcd34d',
    border: 'rgba(245,158,11,0.3)',
  },
  Unknown: {
    bg: 'rgba(239,68,68,0.15)',
    color: '#fca5a5',
    border: 'rgba(239,68,68,0.3)',
  },
};

const fallback = {
  bg: 'rgba(107,114,128,0.2)',
  color: '#d1d5db',
  border: 'rgba(107,114,128,0.3)',
};

interface ScopeBadgeProps {
  scope: string;
}

const ScopeBadge: React.FC<ScopeBadgeProps> = ({ scope }) => {
  const { bg, color, border } = SCOPE_CHIP_COLORS[scope] ?? fallback;
  return (
    <Chip
      label={scope}
      size="small"
      sx={{
        backgroundColor: bg,
        color,
        border: `1px solid ${border}`,
        fontSize: 10,
        height: 20,
        fontWeight: 600,
        '& .MuiChip-label': { px: 1 },
      }}
    />
  );
};

export default ScopeBadge;
